/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState, useEffect } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { Button, Modal, Card, Row, Col, Form, Select, Input, Checkbox, message } from "antd";

import styles from "./../../style.module.scss";
import { useTranslation } from "react-i18next";

// redux & query
import { setReportIssueModalVisible } from "../../goSlice";
import { useAppSelector, useAppDispatch } from "store/hook";
import { useUpdateDeviceData, useReport } from "../../queries";

const { Option } = Select;

const ReportIssueModal: React.FC = () => {
  const [form] = Form.useForm();
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { ticket } = useParams();

  const [viewSolvedOption, setViewSolvedOption] = useState(false);
  const [viewNotSolvedOption, setViewNotSolvedOption] = useState(false);

  const { deviceId, ticketData, reportIssueModalVisible } = useAppSelector((state) => state.goPage);
  const { mutateAsync: useReportMutation } = useReport();

  const issue_report = ticketData?.ticket_inf?.fix_issue_report?.[deviceId]?.issue_report;

  const handleOk = () => {
    dispatch(setReportIssueModalVisible(false));
  };

  const handleCancel = () => {
    dispatch(setReportIssueModalVisible(false));
  };

  const handleSubmit = async (values: any) => {
    await useReportMutation({ values })
      .then(() => {
        message.success(t("ISMS.Success"));
      })
      .catch(() => {
        message.error(t("ISMS.Fail"));
      });
  };

  useEffect(() => {
    form.setFieldsValue({
      cid: ticketData?.ticket_inf?.cid,
      ticket: ticket,
      id: deviceId,
    });
  }, []);

  useEffect(() => {
    form.resetFields();
    form.setFieldsValue({
      cid: ticketData?.ticket_inf?.cid,
      ticket: ticket,
      id: deviceId,
      solve: issue_report?.solve,
      method: issue_report?.method,
      others: issue_report?.solve ? issue_report?.text : null,
      reason: issue_report?.solve ? null : issue_report?.text,
    });

    if (issue_report?.solve === null) {
      setViewSolvedOption(false);
      setViewNotSolvedOption(false);
    } else if (issue_report?.solve) {
      setViewSolvedOption(true);
      setViewNotSolvedOption(false);
    } else {
      setViewSolvedOption(false);
      setViewNotSolvedOption(true);
    }
  }, [issue_report]);

  return (
    <>
      <Modal
        title={t("ISMS.IssueReport")}
        visible={reportIssueModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={[
          <Button
            key="Cancel"
            onClick={() => {
              handleCancel();
            }}
          >
            {t("ISMS.Cancel")}
          </Button>,
          <Button
            type="primary"
            key="Submit"
            onClick={() => {
              form.submit();
              handleCancel();
            }}
          >
            {t("ISMS.Submit")}
          </Button>,
        ]}
      >
        <Form layout="vertical" name="CreateInfo" onFinish={handleSubmit} form={form}>
          <div className="formwrap">
            <Row gutter={24} justify="center">
              <Col xs={24} sm={24} md={24} lg={24} xl={12}>
                <h2>{}</h2>

                <Form.Item label={"Cid"} name={"cid"} hidden={true}>
                  <Input disabled={true} />
                </Form.Item>

                <Form.Item label={t("ISMS.Ticket")} name={"ticket"} hidden={true}>
                  <Input disabled={true} />
                </Form.Item>

                <Form.Item label={t("ISMS.DeviceId")} name={"id"} hidden={true}>
                  <Input disabled={true} />
                </Form.Item>

                <Form.Item
                  label={t("ISMS.IssueCheck")}
                  name="solve"
                  rules={[{ required: true, message: "Required!!" }]}
                >
                  <Select
                    onChange={(value: any) => {
                      if (value === true) {
                        setViewSolvedOption(true);
                        setViewNotSolvedOption(false);
                      }
                      if (value === false) {
                        setViewSolvedOption(false);
                        setViewNotSolvedOption(true);
                        form.resetFields(["method"]);
                      }
                    }}
                    placeholder={t("ISMS.Select")}
                  >
                    <Option value={true}> {t("ISMS.IssueSolved")}</Option>
                    <Option value={false}> {t("ISMS.IssueNotSolved")}</Option>
                  </Select>
                </Form.Item>

                <Form.Item
                  label={""}
                  name="method"
                  hidden={viewSolvedOption === true ? false : true}
                  className={styles.reportIssueMethod}
                  style={{ marginBottom: "15px" }}
                >
                  <Checkbox.Group>
                    <Row gutter={24}>
                      <Col span={24}>
                        <Checkbox value={1} style={{ lineHeight: "32px" }}>
                          {t("ISMS.Reboot")}
                        </Checkbox>
                      </Col>
                      <Col span={24}>
                        <Checkbox value={2} style={{ lineHeight: "32px" }}>
                          {t("ISMS.Replug/ Replace Ethernet Cable")}
                        </Checkbox>
                      </Col>
                      <Col span={24}>
                        <Checkbox value={3} style={{ lineHeight: "32px" }}>
                          {t("ISMS.Reinstall/ Adjust Antenna")}
                        </Checkbox>
                      </Col>
                      <Col span={24}>
                        <Checkbox value={4} style={{ lineHeight: "32px" }}>
                          {t("ISMS.Change Power")}
                        </Checkbox>
                      </Col>
                      <Col span={24}>
                        <Checkbox value={21} style={{ lineHeight: "32px" }} disabled>
                          {t("ISMS.Replace Device")}
                        </Checkbox>
                      </Col>
                    </Row>
                  </Checkbox.Group>
                </Form.Item>

                <Row
                  gutter={24}
                  hidden={viewSolvedOption === true ? false : true}
                  style={{ paddingLeft: "20px", height: "35px" }}
                >
                  <Col>{t("ISMS.Others")}:</Col>
                  <Col flex="auto" className={styles.othersInput} style={{ paddingLeft: 0 }}>
                    <Form.Item label={""} name="others">
                      <Input />
                    </Form.Item>
                  </Col>
                </Row>

                <Form.Item label={t("ISMS.Reason")} name="reason" hidden={viewNotSolvedOption === true ? false : true}>
                  <Input></Input>
                </Form.Item>
              </Col>
            </Row>
          </div>
        </Form>
      </Modal>
    </>
  );
};

export default ReportIssueModal;
